import { ReactNode, createContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFirePageEventMutation } from "src/api/services/patientApi";
import { TrackPage } from "src/api/types";

export const PageTrackerContext = createContext<TrackPage | null>(null);

interface ProviderProps {
  children: ReactNode;
}

const PageTrackerProvider = ({ children }: ProviderProps) => {
  const [firePageEvents] = useFirePageEventMutation();
  const { pathname } = useLocation();
  const [, product] = pathname.split("/");

  useEffect(() => {
    firePageEvents({
      data: { pageUrl: pathname, product },
    });
  }, [pathname, firePageEvents, product]);

  return (
    <PageTrackerContext.Provider value={{ pageUrl: pathname }}>
      {children}
    </PageTrackerContext.Provider>
  );
};

export default PageTrackerProvider;
